var SpriteSymbol = require("../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "external-link",
  "use": "external-link-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"external-link\"><g fill-rule=\"nonzero\"><path d=\"M11.5 4.5V11h1V3.5H5v1z\" /><path d=\"m11.646 3.646-7.755 7.756.707.707 7.756-7.755z\" /></g></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol